import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AppService } from 'app/app.service';
import { filter, first, map } from 'rxjs';

export const radUiGuard: CanMatchFn = () => {
    const appService = inject(AppService);

    return appService.client$.pipe(
        filter(client => !!client),
        first(),
        map(() => appService.flags.radUIEnabled())
    );
}
